import React, { useEffect, useLayoutEffect, useState } from 'react';
import { UTILS } from '../../constants';
import axios from 'axios';
export const LabelPopup = ({
  setgetId,
  cardDetail,
  setLabelData,
  labelData,
  addLabelFunc,
  updateLabelFunc,
  addNewLabelFunc,
  colors,
  setSelectedColor,
  selectedColor,
  getTaskId,
  card,
}) => {
  
  // console.log('cardDetail', cardDetail);
  const [searchInput, setSearchInput] = useState('');
  const [editingLabelId, setEditingLabelId] = useState(null);
  const [editedLabel, setEditedLabel] = useState('');
  const [editedColorId, setEditedColorId] = useState(null);

  const [showNewLabelInput, setShowNewLabelInput] = useState(false);
  const [newLabelText, setNewLabelText] = useState('');
  const [newLabelColor, setNewLabelColor] = useState('#ffffff'); // Default color

  // let [labelData, setLabelData] = useState(cardDetail?.labels);

  // useLayoutEffect(() => {
  //   setLabelData(cardDetail?.labels);
  // }, [cardDetail]);

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };
  const filteredLabels = searchInput
    ? labelData.filter((label) =>
        label.label.toLowerCase().includes(searchInput.toLowerCase())
      )
    : labelData;

  const handleCheckboxChange = (id, assigned) => {
    addLabelFunc(id, assigned);

    // Update the assigned status for the specific label
    const updatedLabels = labelData.map((label) =>
      label.id === id ? { ...label, assigned: !label.assigned } : label
    );

    // Update the state with the new label data
    setLabelData(updatedLabels);
  };

  const handleEditClick = (id, label, color_id) => {
    // console.log("id, label", id, label);
    setEditingLabelId(id);
    setEditedLabel(label);
    setEditedColorId(color_id);
  };
  const handleInputChange = (e) => {
    setEditedLabel(e.target.value);
  };

  const handleSave = (id) => {
    // Update the label in the labelData array
    const updatedLabels = filteredLabels.map((label) =>
      label.id === id ? { ...label, label: editedLabel } : label
    );
    // console.log('updatedLabels', updatedLabels);
    // Update the state with the new label data
    updateLabelFunc(editingLabelId, editedLabel);
    setLabelData(updatedLabels);
    setEditingLabelId(null);
    setEditedLabel('');
    setEditedColorId(null);
  };

  const handleNewLabelClick = () => {
    setShowNewLabelInput(!showNewLabelInput);
  };

  const handleNewLabelTextChange = (e) => {
    setNewLabelText(e.target.value);
  };
  const handleNewLabelColorChange = (e) => {
    setNewLabelColor(e.target.value);
  };
  useEffect(() => {

    let fetchLabel = async () => {
      try {
        const apiUrl =
          UTILS.API_url +
          `board/v1/board-list-cards/label/show${
            card?.id ? `/${card?.id}` : `?code=${getTaskId}`
          }`;

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
            'Content-Type': 'application/json',
            // 'X-CSRF-TOKEN': 'SFy5sniSD26URDuLPmBAKy1C9KocZq9mXWFk0IWA',
          },
        });
        setLabelData(response?.data.label);
      } catch (error) {
        console.error('Error fetching board data:', error);
      }
    };
      fetchLabel();
  }, []);
  const handleSaveNewLabel = () => {
    const generateRandomId = () => {
      return Math.random().toString(36).substr(2, 9);
    };

    const newLabel = {
      id: new Date().getTime(), // Use a unique ID, you might want to replace this with your own logic
      label: newLabelText,
      color: { id: generateRandomId(), value: newLabelColor }, // Default color value
      assigned: false,
    };
    // console.log('newLabelColor', newLabelColor, newLabel);
    // Update the state with the new label data
    // setLabelData([...labelData, newLabel]);
    addNewLabelFunc(newLabelText);
    setShowNewLabelInput(false);
    setNewLabelText('');
    setNewLabelColor('#ffffff');
    setSelectedColor(null);
  };
  // console.log('labelData', labelData);

  return (
    <div>
      <div className="labeldropdown-inner right-side-label-tab">
        <div className="add-member">
          <button
            className="close-btn-pop close-member"
            // onClick={() => props.idLabelPop(null)}
          >
            <span
              className="material-symbols-outlined"
              onClick={() => setgetId(null)}
            >
              close
            </span>
          </button>
          <h4 className="mem-heading">Label</h4>
          <form className="card-label" data-board-card-id="72">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                id="searchMember"
                aria-describedby="searchHelp"
                placeholder="Search Labels"
                value={searchInput}
                onChange={handleSearchChange}
              />
            </div>

            <div className="labels-data">
              {filteredLabels && filteredLabels?.length > 0 ? (
                <>
                  {/* <p>Labels</p> */}
                  {filteredLabels.map((value) => {
                    return (
                      <div
                        key={value?.id}
                        className="form-check"
                        data-board-list-card-id={value?.id}
                        data-color-position="1"
                        data-label-id="233"
                        id={`label-div-${value?.id}-233`}
                      >
                        <input
                          type="checkbox"
                          data-board-list-card-id={value?.id}
                          data-label-id="233"
                          className="form-check-input label-input"
                          id={`labelCheck-${value?.id}-233`}
                          checked={value?.assigned}
                          onChange={() =>
                            handleCheckboxChange(value?.id, value?.assigned)
                          }
                          // onClick={() => props.getLabelId(value?.id)}
                        />
                        {/* <label
                          className="form-check-label"
                          data-color-position="1"
                          data-color-id="6"
                          data-label-id={value?.id}
                          aria-label="Color:"
                          htmlFor={`labelCheck-${value?.id}-233`}
                          style={{ backgroundColor: value?.color?.value}}
                        >
                          {value?.label}
                        </label> */}

                        {editingLabelId === value?.id ? (
                          <input
                            type="text"
                            value={editedLabel}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                        ) : (
                          <label
                            className="form-check-label"
                            data-color-position="1"
                            data-color-id="6"
                            data-label-id={value?.id}
                            aria-label="Color:"
                            htmlFor={`labelCheck-${value?.id}-233`}
                            style={{ backgroundColor: value?.color?.value }}
                          >
                            {value?.label}
                          </label>
                        )}
                        {editingLabelId === value?.id ? (
                          <button
                            type="button"
                            className="show-btn dynamiclabelEditBtn"
                            onClick={() => handleSave(value?.id)}
                            data-target="popover-new"
                          >
                            Update
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="show-btn dynamiclabelEditBtn"
                            onClick={() =>
                              handleEditClick(
                                value?.id,
                                value?.label,
                                value?.color?.id
                              )
                            }
                            data-target="popover-new"
                          >
                            <i className="far fa-edit"></i>
                          </button>
                        )}
                      </div>
                    );
                  })}
                </>
              ) : labelData?.length > 0 ? (
                labelData.map((value) => {
                  return (
                    <div
                      key={value?.id}
                      className="form-check"
                      data-board-list-card-id={value?.id}
                      data-color-position="1"
                      data-label-id="233"
                      id="label-div-72-233"
                    >
                      <input
                        type="checkbox"
                        data-board-list-card-id={value?.id}
                        data-label-id="233"
                        className="form-check-label form-check-input label-input"
                        id="labelCheck-72-233"
                        // onClick={() => props.getLabelId(value?.id)}
                        // checked={value?.assigned}
                        onClick={() => addLabelFunc(value?.id, value?.assigned)}
                      />

                      <label
                        className="form-check-label"
                        data-color-position="1"
                        data-color-id="6"
                        data-label-id={value?.id}
                        data-id={value?.color?.value}
                        aria-label="Color:"
                        for="labelCheck-72-233"
                        style={{ backgroundColor: value?.color?.value }}
                      >
                        {value?.label}
                      </label>
                      <div
                        // type="button"
                        className="show-btn dynamiclabelEditBtn"
                        // onclick="openlabelDiv()"
                        data-target="popover-new"
                        onClick={() => handleEditClick(value?.id, value?.label)}
                      >
                        <i className="far fa-edit"></i>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div>No Label Avaliable</div>
              )}
              {/* <div
                className="form-check"
                data-board-list-card-id="72"
                data-color-position="1"
                data-label-id="233"
                id="label-div-72-233"
              >
                <input
                  type="checkbox"
                  data-board-list-card-id="72"
                  data-label-id="233"
                  className="form-check-label form-check-input label-input"
                  id="labelCheck-72-233"
                />
                <label
                  className="form-check-label"
                  data-color-position="1"
                  data-color-id="6"
                  data-label-id="233"
                  aria-label="Color:"
                  for="labelCheck-72-233"
                >
                  Need More Amazing Mock Design
                </label>
                <button
                  type="button"
                  className="show-btn dynamiclabelEditBtn"
                  onclick="openlabelDiv()"
                  data-target="popover-new"
                >
                  <i className="far fa-edit"></i>
                </button>
              </div>
              <div
                className="form-check"
                data-board-list-card-id="72"
                data-color-position="2"
                data-label-id="234"
                id="label-div-72-234"
              >
                <input
                  type="checkbox"
                  data-board-list-card-id="72"
                  data-label-id="234"
                  className="form-check-label form-check-input label-input"
                  id="labelCheck-72-234"
                />
                <label
                  className="form-check-label"
                  data-color-position="2"
                  data-color-id="7"
                  data-label-id="234"
                  aria-label="Color:"
                  for="labelCheck-72-234"
                >
                  Urgent
                </label>
                <button
                  type="button"
                  className="show-btn dynamiclabelEditBtn"
                  onclick="openlabelDiv()"
                  data-target="popover-new"
                >
                  <i className="far fa-edit"></i>
                </button>
              </div>
              <div
                className="form-check"
                data-board-list-card-id="72"
                data-color-position="4"
                data-label-id="235"
                id="label-div-72-235"
              >
                <input
                  type="checkbox"
                  data-board-list-card-id="72"
                  data-label-id="235"
                  className="form-check-label form-check-input label-input"
                  id="labelCheck-72-235"
                />
                <label
                  className="form-check-label"
                  data-color-position="4"
                  data-color-id="9"
                  data-label-id="235"
                  aria-label="Color:"
                  for="labelCheck-72-235"
                >
                  Most High Priority
                </label>
                <button
                  type="button"
                  className="show-btn dynamiclabelEditBtn"
                  onclick="openlabelDiv()"
                  data-target="popover-new"
                >
                  <i className="far fa-edit"></i>
                </button>
              </div>
              <div
                className="form-check"
                data-board-list-card-id="72"
                data-color-position="6"
                data-label-id="236"
                id="label-div-72-236"
              >
                <input
                  type="checkbox"
                  data-board-list-card-id="72"
                  data-label-id="236"
                  className="form-check-label form-check-input label-input"
                  id="labelCheck-72-236"
                />
                <label
                  className="form-check-label"
                  data-color-position="6"
                  data-color-id="22"
                  data-label-id="236"
                  aria-label="Color:"
                  for="labelCheck-72-236"
                >
                  High Priority Client
                </label>
                <button
                  type="button"
                  className="show-btn dynamiclabelEditBtn"
                  onclick="openlabelDiv()"
                  data-target="popover-new"
                >
                  <i className="far fa-edit"></i>
                </button>
              </div>
              <div
                className="form-check"
                data-board-list-card-id="72"
                data-color-position="7_2"
                data-label-id="237"
                id="label-div-72-237"
              >
                <input
                  type="checkbox"
                  data-board-list-card-id="72"
                  data-label-id="237"
                  className="form-check-label form-check-input label-input"
                  id="labelCheck-72-237"
                />
                <label
                  className="form-check-label"
                  data-color-position="7_2"
                  data-color-id="28"
                  data-label-id="237"
                  aria-label="Color:"
                  for="labelCheck-72-237"
                >
                  Need Amazing Mockup
                </label>
                <button
                  type="button"
                  className="show-btn dynamiclabelEditBtn"
                  onclick="openlabelDiv()"
                  data-target="popover-new"
                >
                  <i className="far fa-edit"></i>
                </button>
              </div> */}
            </div>
            <div
              className="show-more-label d-none"
              data-board-card-id="72"
            ></div>
          </form>
          {showNewLabelInput && (
            <div className="new-label-inputs">
              <input
                type="text"
                value={newLabelText}
                onChange={handleNewLabelTextChange}
                className="form-control"
                placeholder="New Label"
              />
              <input
        type="color"
        value={newLabelColor}
        onChange={handleNewLabelColorChange}
        className="form-control"
        title="Choose your color"
      />

              <div className="colors-label" style={{ margin: '10px 0px' }}>
                {colors.map((value) => {
                  return (
                    <div
                      className="span-color color-select"
                      data-color-position={value.color_position}
                      data-color-id={value.id}
                      style={{
                        backgroundColor: value?.color_value,
                        border:
                          selectedColor === value.id
                            ? '2px solid black'
                            : 'none',
                      }}
                      onClick={() => {
                        setSelectedColor(value?.id);
                        setNewLabelColor(value?.color_value);
                      }}
                    ></div>
                  );
                })}
              </div>
              <button
                type="button"
                className="show-btn dynamiclabelSaveBtn"
                onClick={handleSaveNewLabel}
              >
                Save
              </button>
            </div>
          )}

          {showNewLabelInput == false ? (
            <button
              className="show-btn dynamiclabelBtn"
              onclick="openlabelDiv()"
              data-target="popover-new"
              id="new-label-btn"
              onClick={handleNewLabelClick}
            >
              Create a new label
            </button>
          ) : (
            ''
          )}

          {/* <button className="show-btn show-btn-label showing-toggle">
            Show more label
          </button>
          <button className="show-btn">Enable Colorblind friendly mode</button> */}
        </div>
      </div>
      <div className="popoverContainer popover popover-new">
        <div className="pop-header">
          <button
            className="close-btn close-mov-member return-move-member"
            onclick="returnlabelDiv()"
          >
            <span className="material-symbols-outlined"> arrow_back_ios </span>
          </button>
          <h4 className="mem-mov-heading">Manage Label</h4>
          <button
            className="close-btn close-mov-member"
            onclick="closelabelDiv()"
          >
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>
        <div className="popoverContent">
          <div className="label-color">
            <div className="store-label-text"></div>
          </div>
          <div className="row">
            <div className="col-12">
              <label for="">Title</label>
              <input type="text" className="form-control create-label-text" />
            </div>
            <div className="col-12">
              <div className="color-multi-div">
                <label for="">Select a color</label>
                <div className="colors-label">
                  <div
                    className="span-color color-select"
                    data-color-position="1_1"
                    data-color-id="1"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="2_1"
                    data-color-id="2"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="3_1"
                    data-color-id="3"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="4_1"
                    data-color-id="4"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="5_1"
                    data-color-id="5"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="1"
                    data-color-id="6"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="2"
                    data-color-id="7"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="3"
                    data-color-id="8"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="4"
                    data-color-id="9"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="5"
                    data-color-id="10"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="1_2"
                    data-color-id="11"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="2_2"
                    data-color-id="12"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="3_2"
                    data-color-id="13"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="4_2"
                    data-color-id="14"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="5_2"
                    data-color-id="15"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="6_1"
                    data-color-id="16"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="7_1"
                    data-color-id="17"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="8_1"
                    data-color-id="18"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="9_1"
                    data-color-id="19"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="10_1"
                    data-color-id="20"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="6"
                    data-color-id="22"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="7"
                    data-color-id="23"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="8"
                    data-color-id="24"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="9"
                    data-color-id="25"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="10"
                    data-color-id="26"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="6_2"
                    data-color-id="27"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="7_2"
                    data-color-id="28"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="8_2"
                    data-color-id="29"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="9_2"
                    data-color-id="30"
                  ></div>
                  <div
                    className="span-color color-select"
                    data-color-position="10_2"
                    data-color-id="31"
                  ></div>
                </div>
                <button type="button" className="remov-color-btn remove-color">
                  Remove Color
                </button>
              </div>
            </div>
            <div className="col-12">
              <button type="button" className="create-btn-multi create-label">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
